// NC-1621: who can open/take a note held by someone else (UI gates only).

/** Firm notes: show edit-open controls (popup/dialog). */
function canShowNoteOpenControls(note, { canNoteEdit, isAdmin, canNoteOverride }) {
  if (isAdmin || canNoteOverride) return true;
  return !!canNoteEdit && !['done', 'cancel'].includes(note.status);
}

/** Home notes: show EditNoteOpen (caller still applies v-can note-edit). */
function canShowHomeNoteEdit(item, { isAdmin, canNoteOverride }) {
  if (isAdmin || canNoteOverride) return true;
  return !['done', 'cancel'].includes(item.status);
}

/** After click: open immediately if yours, else confirm takeover (never hard-block). */
function noteOpenAction(staff, username) {
  return staff === username ? 'open' : 'confirm';
}

module.exports = {
  canShowNoteOpenControls,
  canShowHomeNoteEdit,
  noteOpenAction,
};
